import React from "react"
import styled from "styled-components"

export default styled.div`
  display: none;

  @media only screen and (max-width: 640px) {
    display: block;
  }
`



// WEBPACK FOOTER //
// /opt/build/repo/src/components/MobileOnly.js